// Barrel re-export for the exotics-pricer shared primitives. Keeps imports
// tidy in the widget content files.
export { default as Section } from './section';
export type { SectionProps } from './section';
export { default as Row, ROW_LABEL_W } from './row';
export type { RowProps } from './row';
export { default as Cell } from './cell';
export type { CellProps } from './cell';
export { greekColour, brandColour } from './colors';
export type { GreekKind } from './colors';
export { default as SmileSvg } from './smile-svg';
export type { SmileSvgProps } from './smile-svg';
export { default as BandRow, BAND_LABEL_W, BAND_COL_W } from './band-row';
export type { BandRowProps } from './band-row';
export {
  InstrumentCell,
  ContractCell,
  ExpiryCell,
  NotionalCell,
  StrikeCell,
  UpperBarrierCell,
  LowerBarrierCell,
  PayTypeCell,
  CallPutCell,
} from './trade-cells';
export type { InstrumentCellProps } from './trade-cells';
export { StatusCell } from './status-cell';
export {
  dilettaPanelSx,
  dilettaCellSx,
  DILETTA_DIVIDER,
  DILETTA_BANNER_BG,
  DILETTA_TITLE,
  DILETTA_BORDER,
} from './diletta-chrome';

// Compact MUI Select sx — same chrome the band content files were
// inlining. Centralised here so all bands match.
import { SxProps, Theme } from '@mui/material';
export const tightSelectSx: SxProps<Theme> = {
  fontSize: 12,
  '& .MuiSelect-select': { py: 0.5, px: 1 },
  '& fieldset': { borderColor: 'divider' },
};
